module.exports = __webpack_public_path__ + "img/cpzx_card.77ad2c46.png";